import React,	{
	memo,
	useCallback,
	useRef
} from 'react';
import {
	useHistory,
	useParams
} from 'react-router-dom';
import { Form } from 'semantic-ui-react';

import { log } from '../../../services/utils';

import useForm from '../../../hooks/useForm';
import useToggle from '../../../hooks/useToggle';

import { resetPassword } from '../../../api/nora/auth';

import { useUIAction } from '../../../contexts/UIContext';

import Alert from '../../Alert';
import AuthInput from '../AuthInput';
import ConfirmInstructionsPopup from '../../Shared/ConfirmInstructionsPopup';
import PasswordInstructionsPopup from '../../Shared/PasswordInstructionsPopup';
import SubmitButton from '../SubmitButton';

import styles from '../auth.module.css';

const ResetPassForm = () => {
	const history = useHistory();

	const { penCode } = useParams();

	const { setScreenLoader } = useUIAction();

	const passwordInputRef = useRef( null );
	const confirmInputRef = useRef( null );

	const [ passwordInstructionsPopup, togglePasswordInstructionsPopup ] = useToggle( false );
	const [ confirmInstructionsPopup, toggleConfirmInstructionsPopup ] = useToggle( false );
	const [ successModal, toggleSuccessModal ] = useToggle( false );
	const [ errorModal, toggleErrorModal ] = useToggle( false );

	const { formData, updateField } = useForm( {
		penCode,
		password: '',
		confirm: ''
	} );

	const handleSubmit = useCallback( async () => {
		setScreenLoader( 'Processing Request...' );

		try {
			const response = await resetPassword( formData );

			if ( response.status === 200 ) {
				toggleSuccessModal();
			}

			setScreenLoader( '' );
		} catch ( err ) {
			setScreenLoader( '' );
			toggleErrorModal();
		}
	}, [
		formData,
		setScreenLoader,
		toggleErrorModal,
		toggleSuccessModal
	] );

	const handleKeyDown = useCallback( e => {
		if ( e.key === 'Enter' ) {
			handleSubmit();
		}
	}, [ handleSubmit ] );

	const closeSuccessModal = useCallback( () => {
		toggleSuccessModal();
		history.push( '/login' );
	}, [
		history,
		toggleSuccessModal
	] );

	return (
		<>
			{ log( 'resetPassForm' ) }
			<Form className={ styles.inputs }>
				<AuthInput
					autoComplete="chrome-off"
					icon="lock"
					name="password"
					onBlur={ togglePasswordInstructionsPopup }
					onChange={ updateField }
					onFocus={ togglePasswordInstructionsPopup }
					onKeyDown={ handleKeyDown }
					placeholder="New Password"
					type="password"
					value={ formData.password }
					ref={ passwordInputRef }
				/>
				<AuthInput
					autoComplete="chrome-off"
					icon="lock"
					name="confirm"
					onBlur={ toggleConfirmInstructionsPopup }
					onChange={ updateField }
					onFocus={ toggleConfirmInstructionsPopup }
					onKeyDown={ handleKeyDown }
					placeholder="Confirm New Password"
					type="password"
					value={ formData.confirm }
					ref={ confirmInputRef }
				/>
			</Form>
			<SubmitButton
				buttonText="Reset Password"
				onSubmit={ handleSubmit }
			/>
			<PasswordInstructionsPopup
				context={ passwordInputRef }
				open={ passwordInstructionsPopup }
				password={ formData.password }
			/>
			<ConfirmInstructionsPopup
				confirm={ formData.confirm }
				context={ confirmInputRef }
				open={ confirmInstructionsPopup }
				password={ formData.password }
			/>
			<Alert
				name="reset-pass-success-alert"
				heading="Password Reset"
				message="Your password has successfully been reset. Please login using your new password."
				open={ successModal }
				closeModal={ closeSuccessModal }
				closeText="Continue"
				type="success"
			/>
			<Alert
				name="reset-pass-error-alert"
				heading="Unable to Process Request"
				open={ errorModal }
				closeModal={ toggleErrorModal }
				type="error"
			/>
		</>
	);
};

export default memo( ResetPassForm );
